import {
    IonPage, IonContent, IonInput, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import Script from "react-load-script";
import {AccountDenyLog} from "./Service";
import {captchaKeFuAppId, captchaUrl} from "../../../../utils/common";


class AccountDeny extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isShowTip: false,
            showTipMsg: null,
            accounts: '',
            isShow: false,
            token: null,
        }
    }
    handleScriptError = () => {
        this.setShowTipModal('组件加载失败')
    }
    handleScriptLoad = () => {
        this.setState({
            scriptLoaded: true,
        });
    }
    showView = () => {
        const {accounts} = this.state;
        if (accounts === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的账号/游戏ID'
            })
            return;
        }
        const _that = this;
        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
            if (res.ret === 0) {
                const urlParms = {
                    'accounts': accounts,
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                }
                AccountDenyLog(urlParms).then(ret => {
                    if (ret.code === '10000') {
                        let str = '';
                        if (ret.data.indexOf("查询结果：") > 0) {
                            str = ret.data.split("：")[1];
                        }
                        //console.log(str);
                        _that.setState({
                            isShow: true,
                            showTipMsg: str
                        })
                    } else {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.msg
                        })
                    }
                    captcha1.destroy();
                }).catch(err => {
                    console.log(err);
                    captcha1.destroy();
                });
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});
        captcha1.show(); // 显示验证码
    }

    render() {
        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className="phone_top pr mb56">
                            <div className="top_title">封号查询</div>
                        </div>
                        <div className="cont_kf">
                            <Script
                                url={captchaUrl()}
                                onError={this.handleScriptError}
                                onLoad={this.handleScriptLoad}
                            />
                            <div className="phone_input_box pr">
                                <div className="point pa dn"><p>手机号格式错误</p></div>
                                <div className="identity clearfix">
                                    <span className="w280">登陆账号/游戏ID</span>
                                    <IonInput type="text" className="input-tex4"
                                              value={this.state.accounts}
                                              onIonChange={e => this.setState({accounts: e.detail.value})}
                                              placeholder="第三方账号请输入游戏ID"/>
                                </div>
                                <a onClick={() => this.showView()} className="btn_kf mt100">立即查询</a>
                            </div>
                            {this.state.isShow &&
                                <div className="cont">
                                    <div className="cx_tex">
                                        <p>亲爱的用户{this.state.accounts}</p>
                                        <p>查询结果：<span className="textorange">{this.state.showTipMsg}</span></p>
                                    </div>
                                    {/*<a href="#" className="btn mt100">确定</a>*/}
                                </div>
                            }
                        </div>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(AccountDeny);
